// @flow
import get from 'lodash/get';
import { addPageNumber } from '../../../../utils/page';
import messages from '../messages';

/**
 * Title generation logic moved to this class because next/head component doesn't works well with React Components + Intl
 * More info: https://github.com/zeit/next.js/issues/1636
 */
class Title {
  intl: Object;

  verticalName: string;

  categoryName: string;

  serpTitle: string;

  searchParameters: Object;

  params: Object;

  static addCategory = (title: string, categoryName: string) =>
    categoryName ? `${title} - ${categoryName}` : title;

  constructor(
    intl: Object,
    verticalName: string,
    categoryName: string,
    serpTitle: string,
    searchParameters: Object
  ) {
    this.intl = intl;
    this.verticalName = verticalName;
    this.categoryName = categoryName;
    this.serpTitle = serpTitle;
    this.searchParameters = searchParameters;

    this.params = {
      what: get(searchParameters, 'whatAccented'),
      where: get(searchParameters, 'where'),
      categoryId: get(searchParameters, 'type_id'),
    };
  }

  getTitle = (metaTitle: ?boolean) => {
    const title = get(this.searchParameters, 'isSeoUrl')
      ? this.getSeoTitle()
      : this.getUserSearchTitle();

    if (metaTitle) {
      const currentPage = get(this.searchParameters, 'page');
      return `${addPageNumber(title, currentPage, this.intl)} - Trovit`;
    }

    return title;
  };

  getSeoTitle = () => {
    if (this.serpTitle) {
      return this.serpTitle;
    }

    const { what } = this.params;
    if (this.verticalName === 'homes') {
      return `${this.categoryName} ${what}`;
    }

    if (what) {
      return what;
    }

    return '';
  };

  getUserSearchTitle = () => {
    let title = '';

    switch (this.verticalName) {
      case 'homes':
        title = this.getHomesTitle();
        break;
      case 'cars':
        title = this.getCarsTitle();
        break;
      case 'jobs':
        title = this.getJobsTitle();
        break;
      case 'products':
        title = this.getProductsTitle();
        break;
      default:
        break;
    }

    return title;
  };

  getHomesTitle = () => {
    const { what } = this.params;

    if (what) {
      return what;
    }

    return '';
  };

  getCarsTitle = () => {
    const { what } = this.params;

    if (what) {
      return this.intl.formatMessage(messages.yourSearchCars, { '%s': what });
    }

    return '';
  };

  getJobsTitle = () => {
    const { what, where } = this.params;

    // Same what and where from serp search
    if (what && where && what.trim() === where.trim()) {
      return this.intl.formatMessage(messages.yourSearchJobsWhere, { '%s': where });
    }

    if (what && where) {
      return this.intl.formatMessage(messages.yourSearchJobsWhatWhere, {
        '%1$s': what,
        '%2$s': where,
      });
    }

    if (what && !where) {
      return this.intl.formatMessage(messages.yourSearchJobs, { '%s': what });
    }

    if (!what && where) {
      return this.intl.formatMessage(messages.yourSearchJobsWhere, { '%s': where });
    }

    return '';
  };

  getProductsTitle = () => {
    const { what, categoryId } = this.params;
    const categoryPets = categoryId === 104;
    const categoryAll = categoryId === 0;

    if (what && categoryPets) {
      const title = this.intl.formatMessage(messages.yourSearchProductsPets, { '%s': what });
      return Title.addCategory(title, this.categoryName);
    }

    if (what && !categoryPets && !categoryAll) {
      const title = this.intl.formatMessage(messages.yourSearchProducts, { '%s': what });
      return Title.addCategory(title, this.categoryName);
    }

    if (what) {
      return what;
    }

    // @todo: pending of product decision and API keywords implementation
    // if (what && geo && categoryPets) {
    //   return intl.formatMessage(messages.yourSearchProductsPetsGeo, { '%s': what });
    // }

    // @todo: pending of product decision and API keywords implementation
    // if (what && geo && !categoryPets && !categoryAll) {
    //   return intl.formatMessage(messages.yourSearchProductsWhere, { '%1$s': what, '%2$s': geo });
    // }

    return '';
  };
}

export default Title;



// WEBPACK FOOTER //
// ./app/components/shared/Titles/MetaTitle/index.js